import { Card } from '@/components/ui'
import { planStatusSwatchClass } from '@/components/ui/Tone'

const LEGEND: { status: Parameters<typeof planStatusSwatchClass>[0]; label: string }[] = [
  { status: 'met', label: '≥ 100% — План выполнен' },
  { status: 'close', label: '80-99% — Близко к плану' },
  { status: 'missed', label: '< 80% — Значительное отклонение' },
]

export function StatusLegend() {
  return (
    <Card className="p-4">
      <p className="text-sm font-medium mb-3">Статусы исполнения:</p>
      <div className="flex flex-wrap gap-4">
        {LEGEND.map(({ status, label }) => (
          <div key={status} className="flex items-center gap-2">
            <div className={`w-4 h-4 rounded ${planStatusSwatchClass(status)}`} />
            <span className="text-sm text-muted-foreground">{label}</span>
          </div>
        ))}
      </div>
    </Card>
  )
}
